import _ from 'lodash';
import { urlFor } from '~/utils/sanity';
import BackgroundImage from '~/components/sanity/BackgroundImage.vue';
import ContainerVue from '~/components/sanity/Container.vue';
import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
export default {
  name: 'Feature1',
  components: {
    BackgroundImage,
    ContainerVue,
    SanityBlockContent
  },
  props: {
    content: Object,
    styles: Object,
    layout: Object
  },
  data() {
    return {
      header: this.content.header || null,
      subheading: this.content.subheading || null,
      list: this.content.list || null,
      image: this.content.image || null,
      fixedHeight: this.layout.fixedHeight !== false
    };
  },
  computed: {
    featureImageClassObj() {
      return {
        'order-1': this.layout.desktop === 'textOnRight',
        'sm-md:row-start-1 sm-md:row-end-2': this.layout.mobile === 'textOnBottom'
      };
    },
    imageRef() {
      return this.image.asset._ref;
    },
    listIconStyle() {
      return {
        backgroundImage: this.list.listIcon
      };
    },
    showBgImg() {
      if (!this.styles) return false;
      const {
        backgroundImage
      } = this.styles;
      return !_.isUndefined(backgroundImage);
    },
    style() {
      if (!this.styles) return;
      const {
        color,
        backgroundColor
      } = this.styles;
      const style = {
        ...(color && {
          color
        }),
        ...(backgroundColor && {
          backgroundColor
        })
      };
      return style;
    }
  },
  methods: {
    imageUrl(image) {
      return urlFor(image).auto('format').fit('max').url();
    }
  }
};